import { useEffect, useState } from 'react'
import { FieldValues, UseFormReturn } from 'react-hook-form'

import { EMPTY_VALUE } from '@/constants/ui'
import { DirtyFieldChange } from '@/hooks'

import { PASSWORD_MASK } from '../../../../shared/form-changes'

export type ProviderDirtyChange = (isDirty: boolean, getChanges?: () => DirtyFieldChange[]) => void

interface UseProviderEditParams<TValues extends FieldValues> {
  form: UseFormReturn<TValues>
  getChanges: () => DirtyFieldChange[]
  onDirtyChange: ProviderDirtyChange
  serverValues: TValues
}

export const maskSecret = (value: unknown) => (value ? PASSWORD_MASK : EMPTY_VALUE)

export const useProviderEdit = <TValues extends FieldValues>({
  form,
  getChanges,
  onDirtyChange,
  serverValues,
}: UseProviderEditParams<TValues>) => {
  const [isEditing, setIsEditing] = useState(false)
  const { isDirty } = form.formState

  useEffect(() => {
    const isDirtyForm = isEditing && isDirty
    onDirtyChange(isDirtyForm, isDirtyForm ? getChanges : undefined)
  }, [isEditing, isDirty, getChanges, onDirtyChange])

  const cancel = () => {
    form.reset(serverValues)
    setIsEditing(false)
  }

  return { cancel, isEditing, start: () => setIsEditing(true), stop: () => setIsEditing(false) }
}
